import { CanActivateFn, Router } from '@angular/router';
import { Capacitor } from '@capacitor/core';
import { inject } from '@angular/core';
import { LoginSettingsFacade } from '@lyceo/homi/login/data-access';

export function chooseWebsiteGuard(): CanActivateFn {
  return () => {
    const router: Router = inject(Router);
    const websiteSettingsFacade: LoginSettingsFacade =
      inject(LoginSettingsFacade);

    if (Capacitor.getPlatform() !== 'web') {
      const websiteSet: boolean = websiteSettingsFacade.websiteSet();
      if (websiteSet) {
        return router.createUrlTree(['/home']);
      }
      return true;
    }

    return router.createUrlTree(['/home']);
  };
}
